package com.flowyride.data.routing.flowyride

import com.flowyride.core.api.LoopResponseDto
import com.flowyride.core.api.LoopsApi
import com.flowyride.core.api.toDomain
import com.flowyride.core.api.toDto
import com.flowyride.core.domain.loop.GeneratedLoop
import com.flowyride.core.domain.loop.LoopGenerator
import com.flowyride.core.domain.loop.LoopRequest
import com.flowyride.data.routing.internal.routingCall
import com.flowyride.data.routing.internal.toServerRoutingException
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.plugins.timeout
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.contentType
import io.ktor.http.isSuccess

/** [LoopGenerator] running on the rider's FlowyRide server, next to the routing engine. */
class FlowyRideServerLoopGenerator(
    private val client: HttpClient,
    private val baseUrl: String,
) : LoopGenerator {

    override suspend fun generate(request: LoopRequest): GeneratedLoop = routingCall {
        val response = client.post(baseUrl.trimEnd('/') + LoopsApi.PATH) {
            contentType(ContentType.Application.Json)
            setBody(request.toDto())
            // The server chains several engine calls: much longer than a single route.
            timeout {
                requestTimeoutMillis = TIMEOUT_MILLIS
                socketTimeoutMillis = TIMEOUT_MILLIS
            }
        }
        if (!response.status.isSuccess()) throw response.toServerRoutingException(MAX_WAYPOINTS)
        response.body<LoopResponseDto>().toDomain(FlowyRideServerEngine.ID)
    }

    private companion object {
        const val MAX_WAYPOINTS = 150
        const val TIMEOUT_MILLIS = 120_000L
    }
}
